import { VerticalEntity } from 'store/verticals/types'
import { BaseTotalsForTable, PieChartData } from 'utils/types'

export interface EcommerceTotals extends BaseTotalsForTable {
  totalItemsSold: number
  totalReviews: number
  numberOfEmployees?: number
}

export interface EcommerceExtendedEntityForTable extends VerticalEntity {
  totals: EcommerceTotals
}

export interface IEcommerceExtendedSummary {
  sellerRegistryStatus: SummarySellerRegistryStatus
  taxCollectionStatus: SummaryTaxCollectionStatus
  riskScoreDistribution: SummaryRiskScoreDistribution
}

export enum SummaryTitles {
  sellerRegistryStatus = 'Seller Registry Status',
  taxCollectionStatus = 'Overall Tax Collection Upon Checkout',
  riskScoreDistribution = 'Risk Score Distribution',
}

export const SummaryTitlesTooltipText = {
  taxCollectionStatus:
    "Indicates whether sellers are collecting sales tax at the checkout page using IVIX algorithms. Entities marked as 'Not Collecting' may be non-compliant with local tax obligations.",
  riskScoreDistribution:
    "System-assigned risk level based on combined indicators. Entities in 'Critical' or 'High' poses a significant audit or enforcement interest for prioritizing a further investigation",
}

export interface SummarySellerRegistryStatus {
  title: SummaryTitles.sellerRegistryStatus
  pieChartData: PieChartData[]
  total: number
  moreResultsCount: number
}

export interface SummaryTaxCollectionStatus {
  title: SummaryTitles.taxCollectionStatus
  pieChartData: PieChartData[]
  total: number
  moreResultsCount: number
}

export interface SummaryRiskScoreDistribution {
  title: SummaryTitles.riskScoreDistribution
  pieChartData: PieChartData[]
  total: number
  moreResultsCount: number
}
